module.exports = __webpack_public_path__ + "img/dash3.abac9239.png";